/* tslint:disable */
/* eslint-disable */
/**
 * Corrigo API
 * fejlesztői
 *
 * The version of the OpenAPI document: 1.5.2
 * Contact: kerezsigergely@infobex.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
/**
 *
 */
export class StatisticsApi extends runtime.BaseAPI {
    /**
     *  [ID: GetPlansDistribution]
     */
    getPlansDistributionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['window'] == null) {
                throw new runtime.RequiredError('window', 'Required parameter "window" was null or undefined when calling getPlansDistribution().');
            }
            const queryParameters = {};
            if (requestParameters['organization_id'] != null) {
                queryParameters['organization_id'] = requestParameters['organization_id'];
            }
            if (requestParameters['window'] != null) {
                queryParameters['window'] = requestParameters['window'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/orders/plan_distribution`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     *  [ID: GetPlansDistribution]
     */
    getPlansDistribution(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getPlansDistributionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     *  [ID: GetPortalUsage]
     */
    getPortalUsageRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['organization_id'] == null) {
                throw new runtime.RequiredError('organization_id', 'Required parameter "organization_id" was null or undefined when calling getPortalUsage().');
            }
            const queryParameters = {};
            if (requestParameters['organization_id'] != null) {
                queryParameters['organization_id'] = requestParameters['organization_id'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/users/usage_statistics`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     *  [ID: GetPortalUsage]
     */
    getPortalUsage(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getPortalUsageRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     *  [ID: GetSubscriptionStatistics]
     */
    getSubscriptionStatisticsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['organization_id'] != null) {
                queryParameters['organization_id'] = requestParameters['organization_id'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/subscriptions/statistics`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     *  [ID: GetSubscriptionStatistics]
     */
    getSubscriptionStatistics() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.getSubscriptionStatisticsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     *  [ID: GetSubscriptionTimeSeries]
     */
    getSubscriptionTimeSeriesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['organization_id'] == null) {
                throw new runtime.RequiredError('organization_id', 'Required parameter "organization_id" was null or undefined when calling getSubscriptionTimeSeries().');
            }
            if (requestParameters['start_date'] == null) {
                throw new runtime.RequiredError('start_date', 'Required parameter "start_date" was null or undefined when calling getSubscriptionTimeSeries().');
            }
            if (requestParameters['end_date'] == null) {
                throw new runtime.RequiredError('end_date', 'Required parameter "end_date" was null or undefined when calling getSubscriptionTimeSeries().');
            }
            if (requestParameters['interval_unit'] == null) {
                throw new runtime.RequiredError('interval_unit', 'Required parameter "interval_unit" was null or undefined when calling getSubscriptionTimeSeries().');
            }
            if (requestParameters['interval_amount'] == null) {
                throw new runtime.RequiredError('interval_amount', 'Required parameter "interval_amount" was null or undefined when calling getSubscriptionTimeSeries().');
            }
            const queryParameters = {};
            if (requestParameters['organization_id'] != null) {
                queryParameters['organization_id'] = requestParameters['organization_id'];
            }
            if (requestParameters['start_date'] != null) {
                queryParameters['start_date'] = requestParameters['start_date'];
            }
            if (requestParameters['end_date'] != null) {
                queryParameters['end_date'] = requestParameters['end_date'];
            }
            if (requestParameters['interval_unit'] != null) {
                queryParameters['interval_unit'] = requestParameters['interval_unit'];
            }
            if (requestParameters['interval_amount'] != null) {
                queryParameters['interval_amount'] = requestParameters['interval_amount'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/subscriptions/statistics/time_series`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     *  [ID: GetSubscriptionTimeSeries]
     */
    getSubscriptionTimeSeries(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSubscriptionTimeSeriesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     *  [ID: GetUserStatistics]
     */
    getUserStatisticsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['organization_id'] == null) {
                throw new runtime.RequiredError('organization_id', 'Required parameter "organization_id" was null or undefined when calling getUserStatistics().');
            }
            const queryParameters = {};
            if (requestParameters['organization_id'] != null) {
                queryParameters['organization_id'] = requestParameters['organization_id'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/users/statistics`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     *  [ID: GetUserStatistics]
     */
    getUserStatistics(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUserStatisticsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
/**
 * @export
 */
export const GetPlansDistributionWindowEnum = {
    current: 'current',
    total: 'total'
};
/**
 * @export
 */
export const GetSubscriptionTimeSeriesIntervalUnitEnum = {
    day: 'day',
    week: 'week',
    month: 'month'
};
